import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment'
import 'moment/locale/es'

class CommentsList extends Component{
    componentDidMount() {
        this.scrollToBottom();
    }
    componentDidUpdate() {
        this.scrollToBottom();
    }
    scrollToBottom(){
        const messagesContainer = this.refs.messagesContainer;
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
    renderCommentList(){
        if(_.isEmpty(this.props.comments)){
            return(<div className="chat-nomessages"><i className="fa fa-comments fa-5x"></i>Aún no se ha enviado ningún mensaje</div>)
        }
        return this.props.comments.map((comment) => {
            let ballonClass = comment.user_id == this.props.user_id ? 'chatBalloon right' :'chatBalloon left';
            let key = `${comment.id}_${comment.user_id}_${comment.caso_id}`;
            return(
                <div key={key} className={ballonClass}>
                    <div className="chatBalloon-content">
                        {comment.text}
                        <p className="text-muted">{moment.parseZone(comment.updated_at).local().locale('es').format('D [de] MMM YYYY[,] H:mm')}</p>
                    </div>
                </div>
            )
        })
    }
    render(){
        return(
            <div className="chatContainer" ref="messagesContainer">
                {this.renderCommentList()}
            </div>
        )
    }
}



export default CommentsList


// WEBPACK FOOTER //
// ./resources/assets/js/components/comments/CommentsList.jsx